exports = module.exports = require("../../../../../../../../node_modules/_css-loader@0.28.11@css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.flowing-water-detail-wrapper .flowing-water-content[data-v-646e28af] {\n  border: 1px solid #e0e0e0;\n  padding: 20px 40px;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-wrap: wrap;\n      flex-wrap: wrap;\n  line-height: 30px;\n}\n.flowing-water-detail-wrapper .flowing-water-content .flowing-item[data-v-646e28af] {\n    width: 50%;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/_css-loader@0.28.11@css-loader?{"sourceMap":false}!./node_modules/_vue-loader@13.7.3@vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-646e28af","scoped":true,"hasInlineConfig":false}!./node_modules/_sass-loader@6.0.7@sass-loader/lib/loader.js?{"sourceMap":false}!./node_modules/_vue-loader@13.7.3@vue-loader/lib/selector.js?type=styles&index=0!./src/views/personal/flowingWater/components/flowingWaterTable/components/detailDialog/index.vue
// module id = si2H
// module chunks = 1